import { parseFullDomain } from './config'

export function parseInfoUrl(environment, planCode) {
  const slug = {
    TALF: 'komplett-easy',
    TALD: 'komplett-allnet',
  }[planCode]

  const fullDomain = parseFullDomain('homepage', environment)
  const path = `komplettanschluss/${slug}`

  return fullDomain + path
}

export function parseOrderUrl(environment, planCode) {
  const fullDomain = parseFullDomain('orderForm', environment)
  const path = `plans/${planCode}`

  return fullDomain + path
}
